import ApiUrl from "../../../configTools/api";
const User = JSON.parse(localStorage.getItem("user-info"));

const GetProduct = (setValues) => {
    fetch(ApiUrl.Doctor_Product,{
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer '+User.token
        }
    })
    .then(res=>res.json())
    .then(data =>{
        setValues(data.response);
    });
}

const GetProductService = (setValues) => {
    fetch(ApiUrl.Doctor_Product_Service,{
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer '+User.token
        }
    })
    .then(res=>res.json())
    .then(data =>{
        setValues(data.response);
    });
}

const GetProductServiceByProduct = (id,setValues) => {
    fetch(ApiUrl.Doctor_Product_Service+"/"+id,{
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer '+User.token
        }
    })
    .then(res=>res.json())
    .then(data =>{
        setValues(data.response);
    });
}


const Functions = {GetProduct, GetProductService, GetProductServiceByProduct};
export default Functions;